var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2420_132)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 1.16667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4568 2.09977C21.232 0.699923 18.9572 0 15.8075 0H7.05848C6.53353 0 6.00859 0.524941 5.83361 1.04988L2.33398 23.9724C2.33398 24.4974 2.68395 24.8473 3.03391 24.8473H8.45833L9.85817 16.2732V16.6232C10.0332 16.0983 10.5581 15.5733 11.083 15.5733H13.7078C18.7822 15.5733 22.6318 13.4735 23.8567 7.69917V7.17422C24.0316 4.89947 23.6817 3.49962 22.4568 2.09977Z",
    fill: "#263B80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.681 7.17426V7.6992C22.4561 13.6486 18.6066 15.5733 13.5321 15.5733H10.9074C10.3824 15.5733 9.85749 16.0983 9.68251 16.6232L7.9327 27.2971C7.92353 27.3913 7.93534 27.4863 7.96728 27.5754C7.99921 27.6645 8.05048 27.7454 8.11739 27.8123C8.18431 27.8792 8.26522 27.9305 8.3543 27.9624C8.44338 27.9944 8.53844 28.0062 8.63262 27.997H13.1821C13.7071 27.997 14.232 27.6471 14.232 27.1221V26.9471L15.1069 21.5227V21.1727C15.1069 20.6478 15.6319 20.2978 16.1568 20.2978H16.8567C21.2313 20.2978 24.7309 18.548 25.6058 13.2986C25.9558 11.1988 25.7808 9.27403 24.7309 8.04916C24.5102 7.63029 24.1328 7.31576 23.681 7.17426Z",
    fill: "#139AD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4561 6.64926C22.2811 6.64926 22.1061 6.47428 21.9311 6.47428C21.8361 6.48604 21.7397 6.47643 21.6489 6.44616C21.558 6.41589 21.4751 6.36571 21.4062 6.2993C20.7063 6.12431 20.0063 6.12432 19.1314 6.12432H12.3072C12.2122 6.11255 12.1157 6.12216 12.0249 6.15243C11.9341 6.18271 11.8512 6.23288 11.7822 6.2993C11.6215 6.38127 11.4871 6.50676 11.3943 6.66146C11.3014 6.81615 11.254 6.99383 11.2573 7.1742L9.85742 16.2732V16.6232C10.0324 16.0982 10.5573 15.5733 11.0823 15.5733H13.707C18.7815 15.5733 22.631 13.4735 23.8559 7.69915C23.8442 7.60414 23.8538 7.5077 23.884 7.41688C23.9143 7.32606 23.9645 7.24315 24.0309 7.1742C23.6809 6.99922 23.506 6.82424 23.156 6.82424C22.631 6.64926 22.631 6.64926 22.4561 6.64926Z",
    fill: "#232C65"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2420_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 1.16667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/Paypal.a97d4006aa2ec7582b5cb5d3a4b5c196.svg";
export { ForwardRef as ReactComponent };